export const citiesLoaderSelector = (state) => state.location;
